import { useContext } from 'react';
import { ModalContext } from '@/components/context/ModalContext/ModalContext';

export const useModal = () => {
  const modalTools = useContext(ModalContext);

  return modalTools;
};
